/**
 * Collect a flat list of messages from an error value, following the `cause`
 * chain so wrapped errors surface every underlying reason.
 *
 * Used by {@link WidgetError} to populate the "show details" reveal. Guards
 * against reference cycles (`seen`) and runaway depth (`maxDepth`); a value that
 * is neither an `Error` nor a string terminates the walk.
 */
export function collectErrorDetails(error: unknown, maxDepth = 8): string[] {
  const details: string[] = [];
  const seen = new Set<unknown>();
  let current: unknown = error;
  let depth = 0;

  while (current != null && depth < maxDepth && !seen.has(current)) {
    seen.add(current);

    const message =
      current instanceof Error
        ? current.message
        : typeof current === "string"
          ? current
          : undefined;
    if (message) details.push(message);

    current = current instanceof Error ? current.cause : undefined;
    depth++;
  }

  return details;
}
